import PropTypes from 'prop-types';
import { useCallback } from 'react';
// @mui
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
// components
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';

// ----------------------------------------------------------------------

export default function OrderTableToolbar({
    filters,
    onFilters,
    //
    defaultStartDate,
    canReset,
    onResetFilters,
}) {
    const popover = usePopover();

    const handleFilterName = useCallback(
        (event) => {
            onFilters('name', event.target.value);
        },
        [onFilters]
    );

    const handleFilterStartDate = useCallback(
        (newValue) => {
            onFilters('startDate', newValue);
        },
        [onFilters]
    );

    const handleFilterEndDate = useCallback(
        (newValue) => {
            onFilters('endDate', newValue);
        },
        [onFilters]
    );

    return (
        <>
            <Stack
                spacing={2}
                alignItems={{ xs: 'flex-end', md: 'center' }}
                direction={{
                    xs: 'column',
                    md: 'row',
                }}
                sx={{
                    p: 2.5,
                    pr: { xs: 2.5, md: 1 },
                }}
            >
                <DatePicker
                    label="From"
                    value={new Date(defaultStartDate)}  // Use defaultStartDate for display
                    onChange={handleFilterStartDate}
                    slotProps={{
                        textField: {
                            fullWidth: true,
                        },
                    }}
                    sx={{
                        maxWidth: { md: 200 },
                    }}
                />

                <DatePicker
                    label="To"
                    value={filters.endDate}
                    onChange={handleFilterEndDate}
                    slotProps={{ textField: { fullWidth: true } }}
                    sx={{
                        maxWidth: { md: 200 },
                    }}
                />


                {canReset && (
                    <Button
                        color="error"
                        sx={{ flexShrink: 0 }}
                        onClick={onResetFilters}
                        startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
                    >
                        Clear
                    </Button>
                )}
            </Stack>

        </>
    );
}

OrderTableToolbar.propTypes = {
    canReset: PropTypes.bool,
    filters: PropTypes.object,
    onFilters: PropTypes.func,
    onResetFilters: PropTypes.func,
};
